import { Grid, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Fragment } from "react";


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

export default function PhysicianDKWs({ currentPhysician }) {


    return currentPhysician.dkws && <>
        <Typography component="div" variant="h5" sx={{ mt: 6, mb: 2 }}>Expertise for</Typography>
        <Grid container direction="row" spacing={2}>
            {
                currentPhysician.dkws?.map((item, index) => {
                    return <Grid item xs={6} sm={3} key={index} display="flex">
                        <HtmlTooltip
                            title={
                                <Fragment>
                                    {item.meshScopeNote}
                                </Fragment>
                            }
                        >
                            <Button variant="outlined" fullWidth>{item.meshName}</Button>
                        </HtmlTooltip>
                    </Grid>
                })
            }
        </Grid>
    </>
}